import { render, staticRenderFns } from "./BusinessAnnualReturnsTask.vue?vue&type=template&id=60bcc5fe&scoped=true&"
import script from "./BusinessAnnualReturnsTask.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsTask.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsTask.vue?vue&type=style&index=0&id=60bcc5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bcc5fe",
  null
  
)

export default component.exports